import { useNavigate } from 'react-router-dom';
import { videos } from '@/mocks/videos';
import type { Video } from '@/mocks/videos';

export default function HeroSection() {
  const navigate = useNavigate();
  const hotVideos = videos.filter((v) => v.isHot).slice(0, 5);

  const handleViewAll = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => navigate('/category/reboju'), 150);
  };

  const handleVideoClick = (video: Video) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => navigate(`/article/${video.slug}`), 150);
  };

  return (
    <section className="relative w-full min-h-[600px] flex items-center">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Dark%20cinematic%20theater%20interior%20with%20glowing%20red%20velvet%20curtains%20and%20warm%20golden%20stage%20lights%2C%20luxurious%20atmosphere%2C%20dramatic%20spotlight%20beams%2C%20elegant%20movie%20premiere%20setting%2C%20rich%20deep%20colors%2C%20soft%20bokeh%2C%20high%20end%20cinematography%20style&width=1800&height=900&seq=hero-bg-main&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/75"></div>

      <div className="relative w-full px-4 md:px-6 py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center lg:items-start gap-10 lg:gap-16">
            <div className="w-full lg:w-1/2 text-center lg:text-left">
              <span className="inline-flex items-center gap-1.5 bg-accent-500/90 text-background-50 text-xs font-medium px-3 py-1 rounded-full mb-5">
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-fire-fill text-xs"></i>
                </div>
                每日更新 · 追剧不等待
              </span>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4">
                聚合全网热播影视
                <br />
                <span className="text-accent-400">高清在线观看</span>
              </h1>
              <p className="text-base md:text-lg text-white/80 leading-relaxed mb-8 max-w-lg">
                嫩草视频聚合妖精视频、桃花视频、苹果视频、榴莲视频、豆花视频等平台热播影视剧，最新电视剧<strong>完整版</strong>高清在线观看，电影大全每日更新。
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-3">
                <button
                  onClick={handleViewAll}
                  className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer"
                >
                  立即追剧
                  <i className="ri-arrow-right-line ml-2"></i>
                </button>
                <button className="w-full sm:w-auto px-8 py-3 bg-white/10 hover:bg-white/20 text-white rounded-full text-sm font-medium backdrop-blur-sm transition-all whitespace-nowrap cursor-pointer">
                  <i className="ri-information-line mr-2"></i>
                  了解更多
                </button>
              </div>
            </div>

            <div className="w-full lg:w-1/2">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {hotVideos.slice(0, 4).map((video) => (
                  <div
                    key={video.id}
                    className="relative rounded-lg overflow-hidden aspect-video cursor-pointer group"
                    onClick={() => handleVideoClick(video)}
                  >
                    <img
                      src={video.thumbnail}
                      alt={video.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                    <div className="absolute bottom-2 left-2 right-2">
                      <p className="text-white text-xs font-medium line-clamp-1">{video.title}</p>
                      <div className="flex items-center gap-1 mt-0.5">
                        <div className="w-3 h-3 flex items-center justify-center">
                          <i className="ri-star-fill text-accent-400 text-[10px]"></i>
                        </div>
                        <span className="text-white/70 text-[11px]">{video.rating}</span>
                      </div>
                    </div>
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/80 text-background-50">
                        <i className="ri-play-fill text-xl"></i>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}